module.exports = __webpack_public_path__ + "img/friendRequest.3c238c1c.png";